// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/resale/v1/legacy_portal_common.proto (package spwn.resale.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * リセール出品ステータス
 *
 * @generated from enum spwn.resale.v1.LegacyPortalResaleListingStatus
 */
export var LegacyPortalResaleListingStatus;
(function (LegacyPortalResaleListingStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 出品中
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_LISTING = 1;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["LISTING"] = 1] = "LISTING";
    /**
     * 成約・売却完了
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_SOLD = 2;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["SOLD"] = 2] = "SOLD";
    /**
     * 不成立・売れ残り
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSOLD = 3;
     */
    LegacyPortalResaleListingStatus[LegacyPortalResaleListingStatus["UNSOLD"] = 3] = "UNSOLD";
})(LegacyPortalResaleListingStatus || (LegacyPortalResaleListingStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalResaleListingStatus)
proto3.util.setEnumType(LegacyPortalResaleListingStatus, "spwn.resale.v1.LegacyPortalResaleListingStatus", [
    { no: 0, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_LISTING" },
    { no: 2, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_SOLD" },
    { no: 3, name: "LEGACY_PORTAL_RESALE_LISTING_STATUS_UNSOLD" },
]);
/**
 * リセール申込ステータス（申込者個人の当落・申込状態）
 *
 * @generated from enum spwn.resale.v1.LegacyPortalResaleApplicationStatus
 */
export var LegacyPortalResaleApplicationStatus;
(function (LegacyPortalResaleApplicationStatus) {
    /**
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_UNSPECIFIED = 0;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 申込中
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_APPLIED = 1;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["APPLIED"] = 1] = "APPLIED";
    /**
     * 当選
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_WON = 2;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["WON"] = 2] = "WON";
    /**
     * 落選
     *
     * @generated from enum value: LEGACY_PORTAL_RESALE_APPLICATION_STATUS_LOST = 3;
     */
    LegacyPortalResaleApplicationStatus[LegacyPortalResaleApplicationStatus["LOST"] = 3] = "LOST";
})(LegacyPortalResaleApplicationStatus || (LegacyPortalResaleApplicationStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(LegacyPortalResaleApplicationStatus)
proto3.util.setEnumType(LegacyPortalResaleApplicationStatus, "spwn.resale.v1.LegacyPortalResaleApplicationStatus", [
    { no: 0, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_UNSPECIFIED" },
    { no: 1, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_APPLIED" },
    { no: 2, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_WON" },
    { no: 3, name: "LEGACY_PORTAL_RESALE_APPLICATION_STATUS_LOST" },
]);
/**
 * リセール期間・回設定エンティティ（イベント単位）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleRound
 */
export class LegacyPortalResaleRound extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_round_id = 1;
         */
        this.resaleRoundId = "";
        /**
         * イベントFirestoreID
         *
         * @generated from field: string event_firestore_id = 2;
         */
        this.eventFirestoreId = "";
        /**
         * @generated from field: int32 round_number = 3;
         */
        this.roundNumber = 0;
        /**
         * 出品受付開始日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listing_start_at = 4;
         */
        this.listingStartAt = protoInt64.zero;
        /**
         * 出品受付終了日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listing_end_at = 5;
         */
        this.listingEndAt = protoInt64.zero;
        /**
         * 申込受付開始日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 application_start_at = 6;
         */
        this.applicationStartAt = protoInt64.zero;
        /**
         * 申込受付終了日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 application_end_at = 7;
         */
        this.applicationEndAt = protoInt64.zero;
        /**
         * 当落発表日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 lottery_date = 8;
         */
        this.lotteryDate = protoInt64.zero;
        /**
         * イベント名 (event テーブルから取得: title)
         *
         * @generated from field: string event_name = 9;
         */
        this.eventName = "";
        /**
         * 対象券種リスト
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleRoundTicket tickets = 10;
         */
        this.tickets = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleRound().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleRound().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleRound().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleRound, a, b);
    }
}
LegacyPortalResaleRound.runtime = proto3;
LegacyPortalResaleRound.typeName = "spwn.resale.v1.LegacyPortalResaleRound";
LegacyPortalResaleRound.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "round_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "listing_start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "listing_end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "application_start_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "application_end_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "lottery_date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "tickets", kind: "message", T: LegacyPortalResaleRoundTicket, repeated: true },
]);
/**
 * リセール対象券種設定エンティティ（中間テーブル）
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleRoundTicket
 */
export class LegacyPortalResaleRoundTicket extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_round_ticket_id = 1;
         */
        this.resaleRoundTicketId = "";
        /**
         * @generated from field: string resale_round_id = 2;
         */
        this.resaleRoundId = "";
        /**
         * 券種FirestoreID
         *
         * @generated from field: string ticket_firestore_id = 3;
         */
        this.ticketFirestoreId = "";
        /**
         * 申込上限枚数
         *
         * @generated from field: int32 max_applicable_quantity = 4;
         */
        this.maxApplicableQuantity = 0;
        /**
         * 出品手数料率（例: 0.10）
         *
         * @generated from field: double listing_fee_rate = 5;
         */
        this.listingFeeRate = 0;
        /**
         * 出品者受取・振込手数料（例: 330）
         *
         * @generated from field: int32 payout_fee = 6;
         */
        this.payoutFee = 0;
        /**
         * 券種名 (event_ticket テーブルから取得: name)
         *
         * @generated from field: string ticket_name = 7;
         */
        this.ticketName = "";
        /**
         * 券面価格 (event_ticket テーブルから取得: price_jpy)
         *
         * @generated from field: int32 price_jpy = 8;
         */
        this.priceJpy = 0;
        /**
         * サービス手数料 (event_ticket テーブルから取得: service_fee)
         *
         * @generated from field: int32 service_fee = 9;
         */
        this.serviceFee = 0;
        /**
         * 出品情報（自身が出品している場合に設定）
         *
         * @generated from field: repeated spwn.resale.v1.LegacyPortalResaleListing listings = 11;
         */
        this.listings = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleRoundTicket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleRoundTicket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleRoundTicket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleRoundTicket, a, b);
    }
}
LegacyPortalResaleRoundTicket.runtime = proto3;
LegacyPortalResaleRoundTicket.typeName = "spwn.resale.v1.LegacyPortalResaleRoundTicket";
LegacyPortalResaleRoundTicket.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_round_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resale_round_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "max_applicable_quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "listing_fee_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "payout_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "price_jpy", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "service_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "application", kind: "message", T: LegacyPortalResaleApplication, opt: true },
    { no: 11, name: "listings", kind: "message", T: LegacyPortalResaleListing, repeated: true },
    { no: 12, name: "application_total_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 13, name: "listing_total_payout_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
]);
/**
 * リセール出品エンティティ
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleListing
 */
export class LegacyPortalResaleListing extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_listing_id = 1;
         */
        this.resaleListingId = "";
        /**
         * @generated from field: string resale_round_ticket_id = 2;
         */
        this.resaleRoundTicketId = "";
        /**
         * @generated from field: int64 order_id = 3;
         */
        this.orderId = protoInt64.zero;
        /**
         * @generated from field: spwn.resale.v1.LegacyPortalResaleListingStatus status = 4;
         */
        this.status = LegacyPortalResaleListingStatus.UNSPECIFIED;
        /**
         * 出品日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 listed_at = 5;
         */
        this.listedAt = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleListing().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleListing().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleListing().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleListing, a, b);
    }
}
LegacyPortalResaleListing.runtime = proto3;
LegacyPortalResaleListing.typeName = "spwn.resale.v1.LegacyPortalResaleListing";
LegacyPortalResaleListing.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_listing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resale_round_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order_id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(LegacyPortalResaleListingStatus) },
    { no: 5, name: "listed_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * リセール申込エンティティ
 *
 * @generated from message spwn.resale.v1.LegacyPortalResaleApplication
 */
export class LegacyPortalResaleApplication extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string resale_application_id = 1;
         */
        this.resaleApplicationId = "";
        /**
         * @generated from field: string resale_round_ticket_id = 2;
         */
        this.resaleRoundTicketId = "";
        /**
         * @generated from field: int32 quantity = 3;
         */
        this.quantity = 0;
        /**
         * @generated from field: spwn.resale.v1.LegacyPortalResaleApplicationStatus status = 4;
         */
        this.status = LegacyPortalResaleApplicationStatus.UNSPECIFIED;
        /**
         * 申込日時（Unix epoch milliseconds）
         *
         * @generated from field: int64 applied_at = 5;
         */
        this.appliedAt = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LegacyPortalResaleApplication().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LegacyPortalResaleApplication().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LegacyPortalResaleApplication().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LegacyPortalResaleApplication, a, b);
    }
}
LegacyPortalResaleApplication.runtime = proto3;
LegacyPortalResaleApplication.typeName = "spwn.resale.v1.LegacyPortalResaleApplication";
LegacyPortalResaleApplication.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "resale_application_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resale_round_ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "quantity", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(LegacyPortalResaleApplicationStatus) },
    { no: 5, name: "applied_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
//# sourceMappingURL=legacy_portal_common_pb.js.map